// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuebar from 'vuebar'
import VueI18n from 'vue-i18n'
import Locales from './localization/locales'
import Vuex from 'vuex'
import store from './Store/store.js'
import * as settingsApi from 'api/settingsApi'

import P4aUikitPlugin from 'pro4all-ui/P4aUikitPlugin'

import Vuikit from 'vuikit'
import '@vuikit/theme'

import './scss/main.scss'

// window.Promise polyfill
require('es6-promise').polyfill()

Vue.directive('resize', {
  inserted: function (el, binding, vnode) {
    let thElm
    let startOffset

    Array.prototype.forEach.call(
      document.querySelectorAll('.' + el.className),
      function (th) {
        let grip = document.createElement('div')
        grip.classList.add('divider')

        if (binding.value.orientation === 'vertical') {
          grip.style.top = 0
          grip.style.right = 0
          grip.style.bottom = 0
          grip.classList.add('divider--vertical')
        }

        if (binding.value.orientation === 'horizontal') {
          grip.style.left = 0
          grip.style.right = 0
          grip.style.bottom = 0
          grip.classList.add('divider--horizontal')
        }

        grip.style.position = 'absolute'
        grip.addEventListener('mousedown', function (e) {
          grip.classList.add('divider--moving')
          thElm = th
          if (binding.value.orientation === 'vertical') {
            startOffset = th.offsetWidth - e.pageX
          }
          if (binding.value.orientation === 'horizontal') {
            startOffset = th.offsetHeight - e.pageY
          }
        })

        grip.addEventListener('mouseup', function () {
          grip.classList.remove('divider--moving')
        })

        th.appendChild(grip)
      })

    document.addEventListener('mousemove', function (e) {
      if (thElm) {
        if (binding.value.orientation === 'vertical') {
          if (e.pageX > 225 && e.pageX < 500) {
            thElm.style.width = startOffset + e.pageX + 'px'
            thElm.style.minWidth = startOffset + e.pageX + 'px'
            thElm.style.maxWidth = startOffset + e.pageX + 'px'
          }
        }
        if (binding.value.orientation === 'horizontal') {
          if (e.pageY > 255 && e.pageY < (window.innerHeight - 100)) {
            thElm.style.height = startOffset + e.pageY + 'px'
            thElm.style.minHeight = startOffset + e.pageY + 'px'
            thElm.style.maxHeight = startOffset + e.pageY + 'px'
          }
        }
      }
    })

    document.addEventListener('mouseup', function () {
      thElm = undefined
    })
  }
})

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

Vue.use(VueI18n)
Vue.use(P4aUikitPlugin)
Vue.use(Vuebar)
Vue.use(Vuex)
Vue.use(Vuikit)

Vue.config.productionTip = false
Vue.config.devtools = true

const i18n = new VueI18n({
  locale: (window.locale !== undefined && window.locale !== '') ? window.locale : 'nl',
  fallbackLocale: 'nl',
  messages: Locales
})

settingsApi.getUserLanguage().then(lang => {
  i18n.locale = lang
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router: router,
  i18n: i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js